import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { AddressBookWalletModel } from "../model/address-book-wallet.model";
import { TranslationService } from "@core-services/translation.service";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";

@Component({
	selector: "wallet-item",
	templateUrl: "./address-book-wallet-item.component.html",
	styleUrls: ["./address-book-wallet-item.component.scss"],
	standalone: true,
	imports: [CommonModule, TranslationPipeModule]
})
export class AddressBookWalletItemComponent {
	@Input() set wallet({
		asset: { logo: assetLogo },
		network: { logo: networkLogo, name },
		owner_legal_name,
		wallet_address,
		draft
	}: AddressBookWalletModel) {
		this.networkLogo = networkLogo;
		this.assetLogo = assetLogo;
		this.networkName = this.translationService.translate("name_network", [name]);
		this.ownerName = owner_legal_name ?? this.translationService.translate("pending_name");
		this.draft = draft;
		this.walletAddress =
			wallet_address.length > 40
				? wallet_address.substring(0, 6) +
					"..." +
					wallet_address.substring(wallet_address.length - 31, wallet_address.length)
				: wallet_address;
	}
	@Input() hideBottomBorder: boolean = false;

	public assetLogo: string;
	public networkLogo: string;
	public networkName: string;
	public ownerName: string;
	public walletAddress: string;
	public draft: boolean;

	private translationService: TranslationService = inject(TranslationService);
}
